module.exports = __webpack_public_path__ + "img/arbre_1_ombre.196693bf.png";